import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "iapp" }
const _hoisted_2 = { class: "bc mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "home bc-item"
}
const _hoisted_4 = {
  key: 1,
  class: "bc-item bc-info"
}
const _hoisted_5 = { class: "bc-item bc-title" }
const _hoisted_6 = {
  key: 2,
  class: "bc-info bc-item"
}
const _hoisted_7 = {
  class: "scroll-area channel-wrapper",
  ref: "chscroller"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "throbber-spacer" }
const _hoisted_10 = {
  key: 0,
  class: "throbber"
}
const _hoisted_11 = {
  class: "snippet",
  "data-title": ".dot-pulsing"
}
const _hoisted_12 = { class: "avatar-img" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "stage" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot-pulse" })
], -1)
const _hoisted_14 = { class: "channel-area-wrapper" }
const _hoisted_15 = { class: "channel-area d-flex" }
const _hoisted_16 = { class: "chat-editor-frame" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Back = _resolveComponent("Back")!
  const _component_PostActive = _resolveComponent("PostActive")!
  const _component_Info = _resolveComponent("Info")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PostWrapper = _resolveComponent("PostWrapper")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_post = _resolveComponent("post")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_posting_modal = _resolveComponent("posting-modal")!
  const _component_profile_sheet = _resolveComponent("profile-sheet")!
  const _directive_auth_image = _resolveDirective("auth-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.channelStore.getters.isPostSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("a", {
              class: "back",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)), ["prevent"]))
            }, [
              _createVNode(_component_Back)
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.channelStore.getters.isPostSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("a", {
              href: "#",
              class: "",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.newPosting && _ctx.newPosting(...args)), ["prevent"]))
            }, [
              _createVNode(_component_PostActive)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("h2", _hoisted_5, _toDisplayString((_ctx.state.group ? _ctx.state.group.title : '')) + _toDisplayString(_ctx.channelStore.getters.isPostSelected ? '  >  samtale' : ''), 1),
      (!_ctx.channelStore.getters.isPostSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "info-wrap",
              to: '/channels/' + _ctx.state.group?.id + '/info3'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Info, { class: "info" })
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "scroll-area" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_Transition, {
            name: "slidedown87",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.state.messages.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.state.messages.length)
                      ? (_openBlock(), _createBlock(_TransitionGroup, {
                          key: 0,
                          tag: "ul",
                          name: "list",
                          appear: "",
                          id: "channel-messages",
                          class: "channel-messages scrollbox"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.messages, (msg) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: msg.id,
                                class: "message"
                              }, [
                                (_ctx.channelStore.getters.selectedPostId === msg.id || _ctx.channelStore.getters.selectedPostId === '00000000-0000-0000-0000-000000000000')
                                  ? (_openBlock(), _createBlock(_component_PostWrapper, {
                                      key: 0,
                                      msg: msg,
                                      selectedId: _ctx.channelStore.getters.selectedPostId,
                                      onSelectMessage: _ctx.selectMessage,
                                      onEditMessage: _ctx.editPosting,
                                      onShowProfile: _ctx.showProfile
                                    }, null, 8, ["msg", "selectedId", "onSelectMessage", "onEditMessage", "onShowProfile"]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.state.throbber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
                      [_directive_auth_image, _ctx.throbberImage()]
                    ]),
                    _hoisted_13
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_QuillEditor, {
            class: "chat-editor",
            ref: "editor",
            content: _ctx.newMsg,
            options: _ctx.quillOptions,
            onTextChange: _ctx.textChange,
            "content-type": "html",
            theme: "snow"
          }, null, 8, ["content", "options", "onTextChange"]),
          _createElementVNode("button", {
            class: "send-btn btn",
            id: "send-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.send1 && _ctx.send1(...args)))
          }, [
            _createVNode(_component_post)
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.channelStore.getters.isPostSelected]
    ]),
    _createVNode(_component_router_view),
    _createVNode(_component_posting_modal, { ref: "postingmodal" }, null, 512),
    _createVNode(_component_profile_sheet, { ref: "profileSheet" }, null, 512)
  ]))
}